<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">복합결제</span>
      <button
        class="btn-pop-close"
        :disabled="complexPayArr.length > 0"
        @click="$.emit('close')"
      >
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <span class="h2">받을금액</span>
      <div class="fieldset">
        <div class="ip-row">
          <label for="totalPrice">결제금액</label>
          <input
            type="text"
            class="ip-comm"
            id="totalPrice"
            @change="$.emit('complexAmount')"
            :value="
              (complexUprc > 0 ? complexUprc : sumUprc)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
          />
        </div>
      </div>

      <span class="h2">결제수단</span>
      <div class="flex">
        <div class="fieldset-scroll">
          <div class="fieldset-pay-complex">
            <label>
              <span class="lb-yellow" @click="$.emit('complexPay', '001')"
                >현금</span
              >
              <input
                type="text"
                class="ip-comm"
                id=""
                :value="
                  cashUprc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                disabled
              />
            </label>
            <label>
              <span class="lb-yellow" @click="$.emit('complexPay', '002')"
                >카카오페이</span
              >
              <input
                type="text"
                class="ip-comm"
                id=""
                :value="
                  kakaoUprc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                disabled
              />
            </label>
            <label>
              <span class="lb-yellow" @click="$.emit('complexPay', '003')"
                >신용카드</span
              >
              <input
                type="text"
                class="ip-comm"
                id=""
                :value="
                  cardUprc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                disabled
              />
            </label>
            <label>
              <span class="lb-yellow" @click="$.emit('complexPay', '004')"
                >클라우드<br />멤버십</span
              >
              <input
                type="text"
                class="ip-comm"
                id=""
                :value="
                  membersUprc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                disabled
              />
            </label>
            <label>
              <span class="label-npay" @click="$.emit('complexPay', '005')"
                >Npay</span
              >
              <input
                type="text"
                class="ip-comm"
                id=""
                :value="
                  naverUprc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                disabled
              />
            </label>
          </div>
        </div>
        <div class="tb-side-btn">
          <button type="button" class="btn-side-up">
            위로<span class="overlay"></span>
          </button>
          <button type="button" class="btn-side-down">
            아래로<span class="overlay"></span>
          </button>
        </div>
      </div>

      <span class="h2">결제내역</span>
      <div class="flex">
        <table class="tb-lst-payment tb-complex">
          <thead>
            <tr>
              <td>No</td>
              <td>결제구분</td>
              <td>카드/인식번호</td>
              <td>금액</td>
              <td>구분</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(pay, idx) in complexPayArr"
              :key="idx"
              :class="{ on: complexPayIdx == idx }"
              @click="complexPayIdx = idx"
            >
              <td>{{ idx + 1 }}</td>
              <td>
                <template v-if="pay.type == 'cash'">현금</template>
                <template v-else-if="pay.type == 'card'">카드</template>
                <template v-else-if="pay.type == 'naver'">네이버페이</template>
                <template v-else-if="pay.type == 'kakao'">카카오페이</template>
                <template v-else-if="pay.type == 'point'"
                  >멤버쉽포인트</template
                >
                <template v-else>{{ pay.type }}</template>
              </td>
              <td><span>1234-*/***-****</span></td>
              <td>{{ pay.amount }}</td>
              <td>승인</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="pop-btn-area with-scroll-btn col03">
      <div class="btn-arr-area">
        <button type="button" class="admin-btn-up">
          <span class="overlay"></span>
        </button>
        <button
          type="button"
          class="admin-btn-down"
          style="margin-right: var(--comm-pd)"
        >
          <span class="overlay"></span>
        </button>
      </div>
      <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
      <button
        type="button"
        class="btn-pop btn-submit admin-ml08"
        @click="removeComplexPay"
      >
        선택취소<span class="overlay"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "complexPayment",
  props: {
    receivedUprc: Number,
    totalUprc: Number,
    cashUprc: Number,
    kakaoUprc: Number,
    cardUprc: Number,
    totalDiscount: Number,
    membersUprc: Number,
    naverUprc: Number,
    complexUprc: Number,
    complexPayArr: Array,
  },
  data() {
    return {
      complexPayIdx: -1,
    };
  },
  methods: {
    loadingPromise(text) {
      this.$.emit("openLoading", text);
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$.emit("closeLoading");
          resolve(1);
        }, 1000);
      });
    },
    removeComplexPay() {
      if (this.complexPayIdx == -1) return false;
      this.$.emit("removeComplexPayArr", this.complexPayIdx);
      this.complexPayIdx = -1;
    },
  },
  watch: {
    async sumUprc(val) {
      if (val <= 0) {
        await this.loadingPromise("결제완료 처리 중입니다.");
        await this.loadingPromise("영수증 출력 중입니다.");
        this.$.emit("removeComplexPayArr", -1);
        this.$.emit("resetBasket", "003");
        this.$.emit("close");
      }
    },
  },
  computed: {
    sumUprc() {
      let uprc =
        this.totalUprc -
        this.totalDiscount -
        this.cashUprc -
        this.cardUprc -
        this.kakaoUprc -
        this.naverUprc -
        this.membersUprc -
        this.receivedUprc;

      return uprc;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


